import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { AuthProvider, useAuth } from "@/context/AuthContext";
import { SettingsProvider } from "@/context/SettingsContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import LoginPage from "@/pages/LoginPage";
import DashboardPage from "@/pages/DashboardPage";
import ScannerPage from "@/pages/ScannerPage";
import BathDetailPage from "@/pages/BathDetailPage";
import ThirdPartyPage from "@/pages/ThirdPartyPage";
import ReportsPage from "@/pages/ReportsPage";
import AuditPage from "@/pages/AuditPage";
import NotificationsPage from "@/pages/NotificationsPage";
import TrackingPage from "@/pages/TrackingPage";
import UsersPage from "@/pages/UsersPage";
import SettingsPage from "@/pages/SettingsPage";
import SkusPage from "@/pages/SkusPage";
import BarcodeLabelPage from "@/pages/BarcodeLabelPage";
import NotificationPrefsPage from "@/pages/NotificationPrefsPage";
import RolesPage from "@/pages/RolesPage";

function RootRedirect() {
  const { user, loading } = useAuth();
  if (loading) return null;
  if (!user) return <Navigate to="/login" replace />;
  return <Navigate to={user.role === "third_party" ? "/third-party" : "/dashboard"} replace />;
}

function App() {
  return (
    <div className="App min-h-screen">
      <BrowserRouter>
        <AuthProvider>
          <SettingsProvider>
            <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route path="/track" element={<TrackingPage />} />
            <Route path="/track/:code" element={<TrackingPage />} />
            <Route path="/" element={<RootRedirect />} />

            <Route
              path="/dashboard"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <DashboardPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/scanner"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <ScannerPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/reports"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <ReportsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/audit"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <AuditPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/notifications"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <NotificationsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/users"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <UsersPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <SettingsPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/settings/roles"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <RolesPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/skus"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <SkusPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/third-party"
              element={
                <ProtectedRoute>
                  <ThirdPartyPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bath/:id"
              element={
                <ProtectedRoute>
                  <BathDetailPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/bath/:id/label"
              element={
                <ProtectedRoute allowThirdParty={false}>
                  <BarcodeLabelPage />
                </ProtectedRoute>
              }
            />
            <Route
              path="/me/notifications"
              element={
                <ProtectedRoute>
                  <NotificationPrefsPage />
                </ProtectedRoute>
              }
            />

            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
          <Toaster position="top-right" richColors />
          </SettingsProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
